import React, { useState, useEffect } from 'react';
import { GridView, SimpleView, CompositeView, CrudContext } from '@digital/ui';
import { Collapse } from 'antd';
import {
  CicloOrcamentarioProjetoDadosGerais,
  getCicloOrcamentarioProjetoDadosGerais,
} from '@app/api/relatorioCicloorcamentario';
import AbaPacote from './AbaPacote';
import AbaGeralRelatorioCicloOrcamentario from './abaGeralRelatorioCicloOrcamentario';
import GraficoPluriAnual from './GraficoPluriAnual'

const RelatorioCicloOrcamentarioProjetoPluriAnual = () => {
  const { Panel } = Collapse;
  const [cicloOrcamentarioProjetoDadosGerais, setCicloOrcamentarioProjetoDadosGerais] = useState<
    CicloOrcamentarioProjetoDadosGerais
  >();
  const [projetoId, setProjeto] = useState<string>();

  useEffect(() => {
    var projetoId = new URLSearchParams(window.location.search).get('projetoId');

    if (projetoId) {
      setProjeto(projetoId);
      getCicloOrcamentarioProjetoDadosGerais(projetoId).then(data => {
        setCicloOrcamentarioProjetoDadosGerais(data);
      });
    }
  }, []);

  return (
    <SimpleView>
      <CrudContext.Consumer>
        {() => (
          <CompositeView>
            {true && cicloOrcamentarioProjetoDadosGerais ? (
              <GridView icon="commons-document" id="dadosgerais" noform title="DADOS GERAIS">
                <AbaGeralRelatorioCicloOrcamentario
                  cicloOrcamentarioProjetoDadosGerais={cicloOrcamentarioProjetoDadosGerais}
                />
              </GridView>
            ) : (
              () => { }
            )}
            {projetoId ? (
              <GridView icon="commons-document" id={`pacote`} noform title="Pacote">
                <AbaPacote
                  projetoId={projetoId}
                  pageSize={25}
                  mostrarBotalExportarADistribuir={false}
                  nomeProjeto={''}
                  projetoCodigo={''}
                />
              </GridView>
            ) : (
              () => { }
            )}

            {
              projetoId ? (
                <GridView icon="commons-document" id="cursoEconomica" noform title="Curva Econômica" >
                  <GraficoPluriAnual
                    projetoId={projetoId}
                    exportarCurvaEconomicaPluriAnual={true}
                  />
                </GridView>
              ) : (
                () => { }
              )}
          </CompositeView>
        )}
      </CrudContext.Consumer>
    </SimpleView >
  );
};

export default RelatorioCicloOrcamentarioProjetoPluriAnual;
